import Vue from 'vue'
import Vuex from 'vuex'
import http from './http'
import instance from './main'
import router from './router'

Vue.use(Vuex)

const state = {
    baseUrl: `${window.location.protocol}//${window.location.hostname}:2083/`,
    //baseUrl: `http://backup.eventscoded.com:4004/`,
    recaptcha: '6Le63J4UAAAAANKGTWwfswmTDleifEwRuIdAAW-s',
    props: {
        appName: 'Eventscoded',
        width: 0,
        isMobile: false
    },
    dialogs: {
        termsAndConditions: false
    },
    user: {},
    users: [],
    events: [],
    event: {},
    fields: [],
    typeGroups: [],
    activities: [],
    types: [],
    speakers: [],
    registrations: {},
    payments: [],
    messages: [],
    checkpoints: [],
    settings: {},
    allUploadedFiles:[],
    filesToBeUploaded:{},
    filesToBeUpdated:{},
    filesToBeDeleted:[],
    templates: []
}

function camelize (string) {
    return string.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase()
    }).replace(/\s+|-/g, '')
}

const actions = {
    handleErrors ({ state }, e) {
        console.log(e)
        if (e.response && e.response.data) {
            if (e.response.data.message) {
                instance.notify({ type: 'danger', message: e.response.data.message })
            }

            if (e.response.status === 401) {
                instance.notify({ type: 'danger', message: 'Session expired!' })
                router.push({ name: 'login' })
            }
        }
    },
    async signup ({ state, commit, dispatch }, { data, host }) {
        try {
            await http.post(`/auth/register?host=${host}`, data)
            return Promise.resolve()
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async login ({ state, commit, dispatch }, data) {
        try {
            const response = await http.post('/auth/login', data)
            localStorage.token = response.data.token
            Object.assign(http.defaults, { headers: { 'Authorization': `Bearer ${localStorage.token}` } })
            return Promise.resolve(response)
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async verifyUser ({ state, commit, dispatch }, data) {
        try {
            const response = await http.post(`/auth/verify`, data)
            localStorage.token = response.data.token
            Object.assign(http.defaults, { headers: { 'Authorization': `Bearer ${localStorage.token}` } })
            return Promise.resolve()
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async resetPassword ({ state, commit, dispatch }, { data, host }) {
        try {
            await http.post(`/auth/reset-password?host=${host}`, data)
            return Promise.resolve()
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async newPassword ({ state, commit, dispatch }, data) {
        try {
            await http.post(`/auth/new-password`, data)
            return Promise.resolve()
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    logout ({ state, commit, dispatch }) {
        localStorage.removeItem('token')
        Object.assign(http.defaults, { headers: {} })
        commit('SET', ['user', {}])
    },
    async uploadFile ({ state, commit, dispatch }, file) {
        try {
            const data = new FormData()
            data.append('file', file)
            const response = await http.post(`/api/file`, data)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async getAllUploadedFiles ({ state, commit, dispatch }) {
        try {
            const response = await http.get(`/api/registration-uploads`)
            commit('SET', ['allUploadedFiles', response.data.uploads])
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async getUploadedFilesForRegistration ({ state, commit, dispatch }, registrationId) {
        try {
            
            const response = await http.get(`/api/registration-uploads/${registrationId}`,)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async uploadRegistrationFiles ({ state, commit, dispatch }, registrationId) {
        try {
            Object.keys(state.filesToBeUploaded).forEach(async key=>{
                const form = new FormData()
                form.append('registrationId', registrationId)
                form.append('fieldId', state.filesToBeUploaded[key]['fieldId'])
                form.append('file', state.filesToBeUploaded[key]['file'])
                try {
                    await http.post(`/api/registration-uploads`, form)
                } catch (error) {
                    console.log(error);
                }
            })
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async deleteRegistrationFiles ({ state, commit, dispatch }, data) {
        try {
            const response = await http.post(`/api/delete-registration-uploads`, {
                registrationId: data.registrationId,
                fieldIds: data.fieldIds
            })
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async updateRegistrationFile ({ state, commit, dispatch }, registrationId=null) {
        if(state.filesToBeDeleted.length){
            await dispatch('deleteRegistrationFiles', {
                registrationId,
                fieldIds: state.filesToBeDeleted
            })
        }
        try {
            Object.keys(state.filesToBeUpdated).forEach(async key=>{
                const form = new FormData()
                form.append('registrationId', state.filesToBeUpdated[key]['registrationId'])
                form.append('fieldId', state.filesToBeUpdated[key]['fieldId'])
                form.append('file', state.filesToBeUpdated[key]['file'])
                try {
                    await http.patch(`/api/registration-uploads`, form)
                } catch (error) {
                    console.log(error);
                }
            })
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async create ({ state, commit, dispatch }, { path, data }) {
        try {
            const response = await http.post(`/api/${path}`, data)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async update ({ state, commit, dispatch }, { path, data, id, query, forAll=false }) {
        try {
            const response = await http.put(`/api/${path}/${id}?${query}`, { ...data, forAll })
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async remove ({ state, commit, dispatch }, { path, id, query }) {
        try {
            const response = await http.delete(`/api/${path}/${id}?${query}`)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async getAll ({ state, commit, dispatch }, { path, params, query }) {
        try {
            const response = await http.get(`/api/${path}?${query}`, { params })
            path = camelize(path)
            commit('SET', [path, response.data[path]])
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async get ({ state, commit, dispatch }, { path, key, id }) {
        try {
            const response = await http.get(`/api/${path}/${id}`)
            commit('SET', [key, response.data[key]])
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async getUser ({ state, commit, dispatch }) {
        try {
            const response = await http.get('/api/me')
            commit('SET', ['user', response.data.user])
            return Promise.resolve()
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async pay ({ state, commit, dispatch }, id) {
        try {
            const response = await http.post(`/api/payments/${id}/pay`)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async unpay ({ state, commit, dispatch }, id) {
        try {
            const response = await http.post(`/api/payments/${id}/unpay`)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async checkin ({ state, commit, dispatch }, { type, id, registrationId, accept, method, checkinBy={}, isCheckInAll=false, eventId=null }) {
        try {
            const response = await http.post(`/api/checkin/${type}/${id}`, {
                registrationId,
                accept,
                method,
                checkinBy,
                isCheckInAll,
                eventId
            })

            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async updateWithCode ({ state, commit, dispatch }, { path, data, id, code }) {
        try {
            const response = await http.put(`/api/${path}/${id}/${code}`, data)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
    async clearLogs ({ state, commit, dispatch }, data) {
        try {
            const response = await http.post(`/api/loggers/clear`, data)
            return Promise.resolve(response)
        } catch (e) {
            dispatch('handleErrors', e)
            return Promise.reject(e)
        }
    },
}

const mutations = {
    SET: (state, [key, value]) => { state[key] = value },
    SET_PROPS: (state, [key, value]) => { state.props[key] = value },
    SHOW_DIALOG: (state, dialog) => { state.dialogs[dialog] = true },
    HIDE_DIALOG: (state, dialog) => { state.dialogs[dialog] = false },
    PUSH_TO_UPLOADS: (state, val) => {
        state.filesToBeUploaded[val.fieldId] = val
    },
    PUSH_TO_UPDATES: (state, val) => {
        state.filesToBeUpdated[val.fieldId] = val
    },
    REMOVE_FROM_UPLOADS: (state, key) => {
        if(state.filesToBeUploaded[key]) {
            delete state.filesToBeUploaded[key]
        }
    },
    REMOVE_FROM_UPDATES: (state, key) => {
        if(state.filesToBeUpdated[key]) {
            delete state.filesToBeUpdated[key]
        }
    },
    ADD_TO_DELETE_LIST: (state, key) => {
        if(!state.filesToBeDeleted.includes(key)) state.filesToBeDeleted.push(key)
    },
}


const getters = {
    getAuthenticatedUser(state){
        return state.user;
    },
    getTemplates(state){
        return state.templates
    }
}

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
